import React, { useEffect, useMemo, useState } from "react";
import Tab from "../../controls/Tab";
import BlogCard from "../../primitive/cards/BlogCard";
import axios from "axios";
import { ProgressSpinner } from "primereact/progressspinner";

import { useTranslation } from "react-i18next";

const API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const BLOG_ID = process.env.REACT_APP_GOOGLE_BLOG_ID;

const BlogBody = () => {
  const { t } = useTranslation("blog");
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);

  const formatTabName = (name) => {
    return name;
  };
  const labels = useMemo(() => {
    if (!posts?.length) return [];

    return posts?.reduce((previousValue, currentValue) => {
      let in_label_list = previousValue?.some((el) =>
        currentValue?.labels?.includes(el?.toLowerCase())
      );

      currentValue?.labels?.length &&
        !in_label_list &&
        previousValue.push(...currentValue?.labels);
      return previousValue;
    }, []);
  }, [posts]);

  const tabLists = useMemo(() => {
    const tabs = labels.map((el) => {
      return { tabName: formatTabName(el), id: el };
    });
    return [{ tabName: t("blogTablists.tabAll"), id: "all" }, ...tabs];
  });
  const [activeTab, setActiveTab] = useState(tabLists[0].id);

  const getAllPosts = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://www.googleapis.com/blogger/v3/blogs/${BLOG_ID}/posts?key=${API_KEY}`
      );
      setLoading(false);
      const modified_posts = response.data.items?.map((post, idx) => {
        let labels = post?.labels || [];
        return {
          author: post?.author,
          blog: post?.blog,
          content: post?.content,
          etag: post?.etag,
          id: post?.id,
          kind: post?.kind,
          published: post?.published,
          selfLink: post?.selfLink,
          title: post?.title,
          updated: post?.updated,
          url: post?.url,
          labels: labels.map((label) => label?.toLowerCase()),
        };
      });

      setPosts(modified_posts);
    } catch (error) {
      console.error({ error });
    }
  };

  const filtered_post = useMemo(
    () =>
      activeTab === "all"
        ? posts
        : posts?.filter((post) => post.labels?.includes(activeTab)),
    [posts, activeTab]
  );

  useEffect(() => {
    getAllPosts();
  }, []);

  return (
    <div className="container mx-auto space-y-10">
      <div className="flex flex-col space-y-4 md:space-y-0 md:flex-row md:space-x-20 pb-10 md:pb-24">
        <div className="w-full md:w-[30%]">
          {tabLists.map((tab) => (
            <Tab
              key={tab.id}
              tabName={tab.tabName}
              active={tab.id === activeTab}
              onClick={() => setActiveTab(tab.id)}
            />
          ))}
        </div>
        <div className="w-full md:w-[70%]">
          {loading ? (
            <ProgressSpinner
              style={{ width: "40px", height: "40px" }}
              className="flex justify-center items-center lg:ml-[25rem] md:ml-[10rem] mt-[10rem]"
              strokeWidth="8"
              fill="white"
              animationDuration=".5s"
            />
          ) : (
            <>
              {filtered_post?.length ? (
                <div className="space-y-7">
                  {filtered_post.map((card, index) => (
                    <BlogCard
                      key={index}
                      date_posted={card?.published}
                      heading={card?.content}
                      link={card?.url}
                      blog_post_image={card?.author.image.url}
                      category={card?.category}
                      blog_title={card?.title}
                      id={card?.id}
                      labels={card.labels}
                    />
                  ))}
                </div>
              ) : (
                <h4 className="flex justify-center items-center ml-[10rem] mt-[10rem] capitalize">
                  {activeTab === "all"
                    ? "No blog post found"
                    : `no ${activeTab?.replace(/_/g, " ")} blog post found`}
                </h4>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
export default BlogBody;
